const asRecord = (value: unknown): Record<string, unknown> =>
  value && typeof value === "object" ? (value as Record<string, unknown>) : {};

const pickString = (value: unknown): string => (typeof value === "string" ? value : "");

export const capitalizeWords = (name: string) =>
  name
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const buildDisplayName = (authUser: unknown, authSession: unknown): string => {
  const userRecord = asRecord(authUser);
  const userInner = asRecord(userRecord.user);
  const sessionRecord = asRecord(authSession);
  const sessionClient = asRecord(sessionRecord.client);
  const sessionData = asRecord(sessionRecord.session_data);
  const sessionDataClient = asRecord(sessionData.client);

  const fullName =
    pickString(userInner.full_name) ||
    [pickString(userInner.last_name), pickString(userInner.first_name)].filter(Boolean).join(" ") ||
    [pickString(sessionClient.last_name), pickString(sessionClient.first_name)]
      .filter(Boolean)
      .join(" ") ||
    [pickString(sessionDataClient.last_name), pickString(sessionDataClient.first_name)]
      .filter(Boolean)
      .join(" ") ||
    "";

  return capitalizeWords(String(fullName || "").trim());
};

export const getInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "U";
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return `${parts[0].slice(0, 1)}${parts[parts.length - 1].slice(0, 1)}`.toUpperCase();
};
